import React from "react";
import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";

const AttributeResponsive = ({ label, value, borderBottom = true, borderTop = false, padding = 2 }) => {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const valueIsString = typeof value === "string";
    const borderColor = theme.palette.davysGray.main;
    const borderBottomStyle = borderBottom ? `1px solid ${borderColor}` : "none";
    const borderTopStyle = borderTop ? `1px solid ${borderColor}` : "none";

    return (
        <Box sx={{borderBottom: borderBottomStyle, borderTop: borderTopStyle, padding: theme.spacing(padding)}}>
            <Grid container spacing={theme.spacing(isMobile ? 2 : 4)}>
                <Grid item xs={12} sm={3} textAlign={isMobile ? "center" : "right"}>
                    <Typography color="textSecondary" fontWeight="bold">{label}</Typography>
                </Grid>
                <Grid item xs={12} sm={9} textAlign={isMobile ? "center" : "left"}>
                    {
                        valueIsString ? <Typography color="primary">{value ?? "-"}</Typography> : value
                    }
                </Grid>
            </Grid>
        </Box>
    )
}

export default AttributeResponsive;
